import { Slide, toast, ToastOptions } from 'react-toastify';

export const toastOptions: ToastOptions = {
  position: toast.POSITION.TOP_CENTER,
  closeButton: false,
  autoClose: 6000,
  transition: Slide,
  hideProgressBar: true,
  closeOnClick: true,
  draggable: true,
};
